module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae36815"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-collapse/src/Collapse.vue
// module id = 437
// module chunks = 40